import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectQuotView } from '../../Selectors/Master/ItemSelectors';
import { fetchQuotViewlist } from '../../../Store/PHPSlice/Sale/Quotation';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';

const QuotationInfo = () => {
    const [formData, setFormData] = useState({
        itemNm: '',
        firmNm: '',
        priceNm: '',
        partyNm: '',
        schlNm: '',
        jobrate: '',
        outSrc: '',
        extra: '',
        mcloth: '',
        mrate: '',
        mpanna: '',
        m1cloth: '',
        m1rate: '',
        m1panna: '',
        m2cloth: '',
        m2rate: '',
        m2panna: '',
        m3cloth: '',
        m3rate: '',
        m3panna: '',
        profit: '',
        loss: '',
        quotNo: '',
        nar: ''
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    const viewlist = useSelector(selectQuotView);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed

    useEffect(() => {
        dispatch(fetchQuotViewlist(Id))
    }, [Id, dispatch]);

    useEffect(() => {
        if (viewlist?.data && viewlist?.data?.length > 0) {
            const item = viewlist?.data[0];
            setFormData(prev => ({
                ...prev,
                itemNm: item.itemNm || '',
                firmNm: item.firmNm || '',
                priceNm: item.grpNm || '',
                partyNm: item.partyNm || '',
                schlNm: item.schoolNm || '',
                jobrate: item.jobrate || '',
                outSrc: item.outSrc || '',
                extra: item.extra || '',
                mcloth: item.clothNm || '',
                mrate: item.rate || '',
                mpanna: item.panna || '',
                m1cloth: item.m1cloth || '',
                m1rate: item.m1rate || '',
                m1panna: item.m1panna || '',
                m2cloth: item.m2cloth || '',
                m2rate: item.m2rate || '',
                m2panna: item.m2panna || '',
                m3cloth: item.m3cloth || '',
                m3rate: item.m3rate || '',
                m3panna: item.m3panna || '',
                // profit: item.profit || '',
                scrTomil: item.scrtomil || 0,
                milToparty: item.miltoparty || 0,
                loss: item.loss || '',
                quotNo: item.quotNo || '',
                retailerId: item.retailerId,
                retailerNm: item.retailerNm,
                retailerPer: item.retailerPer,
                mrpPer: item.mrpPer,
                groupId: item.groupId,
                nar: item.nar
            }));
        }
    }, [viewlist]);
    // console.log(viewlist)

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    var itemData = viewlist?.avgs?.length > 0 ? {
        size: viewlist.avgs.map(val => val.size),
        mavg: viewlist.avgs.map(val => parseFloat(val.mavg)),
        m1avg: viewlist.avgs.map(val => parseFloat(val.m1avg)),
        m2avg: viewlist.avgs.map(val => parseFloat(val.m2avg)),
        m3avg: viewlist.avgs.map(val => parseFloat(val.m3avg)),
        rate: viewlist.avgs.map(val => parseFloat(val.rate)),
        mrp: viewlist.avgs.map(val => parseFloat(val.mrp))
    } : [];


    function calculateMRP(percentage, milVal) {
        const per_mrp = percentage / 100;
        const per_mrp2 = 1 - per_mrp;

        if (per_mrp2 <= 0) return 0; // safety check

        const updatemrp = Math.round(milVal / per_mrp2);

        let modVal = updatemrp % 5;
        let ans;

        if (modVal > 2.5) {
            ans = updatemrp + (5 - modVal);
        } else {
            ans = updatemrp - modVal;
        }

        // final rounding to nearest multiple of 5
        return Math.ceil(ans / 5) * 5;
    };

    const percentAdd = (base, per) =>
        Math.round(Number(base) + (Number(base) * Number(per)) / 100);

    // console.log(viewlist)
    const renderTableRow = (size, index) => {
        const newAvgM = itemData.mavg[index];
        const newAvgM1 = itemData.m1avg[index];
        const newAvgM2 = itemData.m2avg[index];
        const newAvgM3 = itemData.m3avg[index];

        // var m0rate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.rate)) : 0;
        // var m1rate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.m1rate)) : 0;
        // var m2rate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.m2rate)) : 0;
        // var m3rate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.m3rate)) : 0;

        // var outSrc = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.outSrc)) : 0;

        var m0rate = viewlist.data.length > 0 ? parseFloat(viewlist.data[0].rate) : 0;
        var m1rate = viewlist.data.length > 0 ? parseFloat(viewlist.data[0].m1rate) : 0;
        var m2rate = viewlist.data.length > 0 ? parseFloat(viewlist.data[0].m2rate) : 0;
        var m3rate = viewlist.data.length > 0 ? parseFloat(viewlist.data[0].m3rate) : 0;

        var outSrc = parseFloat(formData.outSrc);

        let mCal = parseFloat(m0rate) * parseFloat(outSrc) / 100 + parseFloat(m0rate);
        let m1Cal = parseFloat(m1rate) * parseFloat(outSrc) / 100 + parseFloat(m1rate);
        let m2Cal = parseFloat(m2rate) * parseFloat(outSrc) / 100 + parseFloat(m2rate);
        let m3Cal = parseFloat(m3rate) * parseFloat(outSrc) / 100 + parseFloat(m3rate);

        // let mCal = m0rate * outSrc / 100 + m0rate;
        // let m1Cal = m1rate * outSrc / 100 + m1rate;
        // let m2Cal = m2rate * outSrc / 100 + m2rate;
        // let m3Cal = m3rate * outSrc / 100 + m3rate;


        // console.log(mCal)

        // let fm0 = mCal * parseFloat(newAvgM) / 100;
        // let fm1 = m1Cal * parseFloat(newAvgM1) / 100;
        // let fm2 = m2Cal * parseFloat(newAvgM2) / 100;
        // let fm3 = m3Cal * parseFloat(newAvgM3) / 100;

        // let fm0 = m0rate * parseFloat(newAvgM);
        // let fm1 = m1rate * parseFloat(newAvgM1);
        // let fm2 = m2rate * parseFloat(newAvgM2);
        // let fm3 = m3rate * parseFloat(newAvgM3);

        let fm0 = mCal * parseFloat(newAvgM);
        let fm1 = m1Cal * parseFloat(newAvgM1);
        let fm2 = m2Cal * parseFloat(newAvgM2);
        let fm3 = m3Cal * parseFloat(newAvgM3);

        let clothrate = Math.round(fm0) + Math.round(fm1) + Math.round(fm2) + Math.round(fm3);
        var jobrate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.jobrate)) : 0;
        let calJob = Math.round(clothrate) + parseFloat(jobrate);

        let val_loss = formData.loss ? parseFloat(formData.loss) : 0;
        let cal_loss = calJob * val_loss / 100;
        let final_loss = Math.round(cal_loss + calJob);

        var extra = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.extra)) : 0;
        let cost = Math.round(final_loss) + parseFloat(extra);

        let firmPer = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.firmPer)) : 0;
        let mrp = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.mrpPer)) : 0;

        // let profit = cost * parseFloat(firmPer) / 100;
        let scrtomil = cost * parseFloat(formData.scrTomil) / 100;
        let finalScrTomil = Math.round(cost + scrtomil);
        let miltoparty = finalScrTomil * parseFloat(formData.milToparty) / 100;
        let finalmilToparty = Math.round(finalScrTomil + miltoparty);
        let finalretailer = percentAdd(finalmilToparty, formData.retailerPer);
        let finalMrp1 = calculateMRP(formData.mrpPer, finalmilToparty);
        //  let finalMrp = Math.ceil((finalMrp1 + finalmilToparty) / 5) * 5;
        let finalMrp = Math.ceil(finalMrp1 / 5) * 5;

        // let calMrp1 = parseFloat(mrp) / 100;
        // let calMrp2 = 1 - calMrp1;
        // let finalMrp = Math.round(finalRate / calMrp2);

        // let mod = finalMrp % 5;
        // if (mod > 2.5) {
        //     let diff = 5 - mod;
        //     var ans = finalMrp + Math.round(diff);
        // } else {
        //     ans = finalMrp - Math.round(mod);
        // }
        return (
            <TableRow key={index}>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{size}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{newAvgM}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(fm0)}</TableCell>
                {formData.m1cloth !== '0' && <>
                    <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{newAvgM1}</TableCell>
                    <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(fm1)}</TableCell>
                </>
                }
                {formData.m2cloth !== '0' &&
                    <>
                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{newAvgM2}</TableCell>
                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(fm2)}</TableCell>
                    </>
                }
                {formData.m3cloth !== '0' &&
                    <>
                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{newAvgM3}</TableCell>
                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(fm3)}</TableCell>
                    </>
                }
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(clothrate)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(calJob)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(final_loss)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(cost)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(finalScrTomil)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(finalmilToparty)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(finalretailer)}</TableCell>
                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(finalMrp)}</TableCell>
            </TableRow>
        );
    };


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Quotation View</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>

                                <tr>
                                    <td style={{ width: '200px' }}>Item Name</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.itemNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Quot. No.</td>

                                    <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.quotNo}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Firm Name</td>

                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.firmNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Extra</td>

                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.extra}</td>
                                </tr>

                                <tr>

                                    <td style={{ width: '200px', paddingLeft: '2%' }}>
                                        Cloth Out Source <br />
                                        <span style={{ color: 'red' }}>(Main + Matching %)</span>
                                    </td>

                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.outSrc}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Job Rate</td>

                                    <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.jobrate}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Main Cloth</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.mcloth} <b>Panna:{formData.mpanna}</b> <b className='red-color'>Rate:{formData.mrate}</b></td>
                                    {formData.m1cloth !== '0' && (
                                        <>
                                            <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-1</td>

                                            <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m1cloth} <b>Panna: {formData.m1panna}</b> <b className='red-color'> Rate: {formData.m1rate}</b></td>
                                        </>
                                    )}
                                </tr>
                                <tr>

                                    {formData.m2cloth !== '0' && (
                                        <>
                                            <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-2</td>

                                            <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m2cloth} <b>Panna: {formData.m2panna}</b> <b className='red-color'> Rate: {formData.m2rate}</b></td>
                                        </>
                                    )}

                                    {formData.m3cloth !== '0' && (
                                        <>
                                            <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-3</td>

                                            <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m3cloth} <b>Panna: {formData.m3panna}</b> <b className='red-color'> Rate: {formData.m3rate}</b></td>
                                        </>
                                    )}
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Party</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData.partyNm}</td>
                                    <td style={{ width: '200px' }}>School</td>

                                    <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.schlNm}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>SCR To MIL (%)</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData.scrTomil}</td>
                                    <td style={{ width: '200px' }}>MIL To Party (%)</td>

                                    <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.milToparty}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Retailer</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData?.retailerNm}</td>
                                    <td style={{ width: '200px' }}>Value of Loss +</td>

                                    <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.loss}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Group ID</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData?.groupId}</td>
                                    <td style={{ width: '200px' }}>Naration</td>

                                    <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.nar}</td>

                                </tr>
                            </tbody>

                        </table>

                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Main Avg.Mtr</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{`Main Avg.Mtr Rate`} <br />+ <span style={{ color: 'red', fontSize: '12px' }}>{`Outsrc(${formData.outSrc}%)`}</span></TableCell>
                                        {formData.m1cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>M1 Avg.Mtr</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>M1 Avg.Mtr Rate <br /> + <span style={{ color: 'red', fontSize: '12px' }}>{`Outsrc(${formData.outSrc}%)`}</span></TableCell>
                                            </>
                                        }
                                        {formData.m2cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>M2 Avg.Mtr</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>M2 Avg.Mtr Rate <br />+ <span style={{ color: 'red', fontSize: '12px' }}>{`Outsrc(${formData.outSrc}%)`}</span></TableCell>
                                            </>
                                        }
                                        {formData.m3cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>M3 Avg.Mtr</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>M3 Avg.Mtr Rate <br />+ <span style={{ color: 'red', fontSize: '12px' }}>{`Outsrc(${formData.outSrc}%)`}</span></TableCell>
                                            </>
                                        }
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Cloth Rate <br /> <span style={{ color: 'red', fontSize: '12px' }}>(Main + Matching)</span></TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Job Rate <br /> <span style={{ color: 'red', fontSize: '12px' }}>(+{formData.jobrate})</span></TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Value of Loss <br /> <span style={{ color: 'red', fontSize: '12px' }}>{`(${formData.loss}%)`}</span> </TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Extra / NLNP<br /> <span style={{ color: 'red', fontSize: '12px' }}>(+{formData.extra})</span></TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>SCR To MIL <br /> <span style={{ color: 'red', fontSize: '12px' }}>{`(${formData.scrTomil}%)`}</span></TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>MIL To Party <br /> <span style={{ color: 'red', fontSize: '12px' }}>{`(${formData.milToparty}%)`}</span></TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Retailer <br /> <span style={{ color: 'red', fontSize: '12px' }}>{`(${formData.retailerPer}%)`}</span></TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>MRP <br /> <span style={{ color: 'red', fontSize: '12px' }}>{`(${formData.mrpPer}%)`}</span></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {itemData.size ? itemData.size.map((item, index) => renderTableRow(item, index)) : ''}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default QuotationInfo;
